import React from 'react'
import Topic from 'scripts/components/content/Topic'
import Thumbnail from 'scripts/components/thumbnail/Thumbnail'
import Constants from 'scripts/base/Constants'
import { placeHolders } from 'scripts/helpers/PlaceHolders'
import { isMobile } from 'scripts/lib/utils'
import { GenerateLink } from 'scripts/helpers/AppHelper'
import locale from 'shared/i18n/react'

const GetTopic = Topic(SpotlightThumbnail)

function SpotlightThumbnail(props) {
  return (
    <Thumbnail
      {...props}
    />
  )
}

class Spotlight extends React.Component {
  constructor(props) {
    super(props)
    this.topic = Constants.Spotlight[locale.getLanguage()]
  }
  renderMoreBtn = () => {
    if (isMobile()) {
      return (
        <GenerateLink {...this.topic} title={locale.general.spotlight} type="tag" cssClass="btn btn-unicorn btn-block" element={locale.buttons.seeAll} />
      )
    }
  }

  render() {
    return (
      <React.Fragment>
        <GetTopic
          {...this.topic}
          type="tag"
          title={locale.general.spotlight}
          limit={(!isMobile()) ? 6 : 3}
          page={1}
          size={6}
          linktype="tag"
          placeHolders={placeHolders(6)}
          section="spotlight"
        />
        <div className="section">
          {this.renderMoreBtn()}
        </div>
      </React.Fragment>
    )
  }
}

export default Spotlight



// WEBPACK FOOTER //
// ./assets/js/components/Spotlight.jsx